// src/pages/quality/QualityFieldOptionsPage.jsx
import { useState } from 'react';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import FieldOptionsForm from '../../components/quality/FieldOptionsForm';

const QualityFieldOptionsPage = () => {
  const { projects: userProjects } = useAuth();
  const [selectedProject, setSelectedProject] = useState(null);

  const handleProjectChange = (e) => {
    const value = e.target.value;
    const project = userProjects.find(p => p.id === Number(value)) || null;
    setSelectedProject(project);
  };

  return (
    <div className="quality-field-options-page">
      <h2>Настройка вариантов полей</h2>
      
      <div className="form-group">
        <label>Выберите проект:</label>
        <select 
          className="form-control"
          value={selectedProject ? selectedProject.id : ''}
          onChange={handleProjectChange}
          disabled={!userProjects.length}
        >
          <option value="">-- Выберите проект --</option>
          {userProjects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name_text}
            </option>
          ))}
        </select>
      </div>

      {selectedProject && (
        <div className="mt-4">
          <FieldOptionsForm 
            project={selectedProject} 
            onClose={() => setSelectedProject(null)} 
          />
        </div>
      )}
    </div>
  );
};

export default QualityFieldOptionsPage;